import React from 'react'
import LaurelsTitle from './LaurelsTitle'
import TryButton from './TryButton'
import { useTheme } from '@/components/ThemeProvider'

const Hero = ({ isWhitePage, title }: { isWhitePage?: boolean; title?: string }) => {
  const { theme } = useTheme()
  return (
    <section className="pt-[26px] rounded-b-5xl relative mb-8 dark:before:absolute before:w-full before:h-full before:top-0 before:left-0 dark:before:bg-heroBgGradient before:bg-no-repeat before:z-[-1]">
      <LaurelsTitle secondary={theme === 'light'} />
      <div className="flex flex-col relative z-[1] items-center px-4 pb-4 -mt-10">
        <img
          src={theme === 'light' ? '/img/hero/light/2.webp' : '/img/hero/2.webp'}
          alt="Hero background"
          className="absolute top-0 left-0 w-full h-full object-cover rounded-b-5xl z-[-1]"
        />
        <figure className="max-w-[95%] aspect-[289/227] mt-[60px] mx-auto">
          <img
            src={theme === 'light' ? '/img/hero/light/1.webp' : '/img/hero/1.webp'}
            alt="Clean up your camera roll & enjoy the memories with Clean Master!"
            className="w-full z-[1]"
          />
        </figure>
        <h2 className="mb-3 font-bold text-XL text-center">
          {title || 'Clean up your camera roll & enjoy the memories with Clean Master!'}
        </h2>
        <p className="mb-6 text-center text-grayText text-logo">Who Said Cleaning Can’t Be Fun?</p>
        <TryButton withShadow to={isWhitePage ? '/email' : '/scan-results'} />
      </div>
    </section>
  )
}

export default Hero
